import { useState } from 'react';

const usePaginationState = () => {
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [totalCount, setTotalCount] = useState(null);
  return { page, setPage, size, setSize, totalCount, setTotalCount };
};

export default usePaginationState;
